export const LinkThumbnailConfig = Object.freeze({
    place: "/mapAppRoot/thumbnail/default_geocode-1x.png"
})